// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { DataTableProps } from "@insite/mobius/DataTable";
import { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import xOrderInformationStyles from "@keller/App/SharedStyle/MyAccount/Details/OrderInformationStyles";
import { css } from "styled-components";

interface MyAccountOrderListTableStyle {
    dataTable?: DataTableProps;
    rightAlignHead?: DataTableHeaderProps;
}

const xOrderListTableStyle: MyAccountOrderListTableStyle = {
    dataTable: {
        css: css`
            td[class^="DataTableCellBase"] {
                & > ${TypographyStyle} {
                    font-size: 15px;
                    letter-spacing: 0;
                    line-height: 24px;
                }
                & > ${TypographyStyle}:empty:after {
                    content: "--";
                }
            }
        `,
    },
    rightAlignHead: {
        alignX: "right",
        sortClickableProps: {
            css: css`
                &&& {
                    justify-content: flex-end;
                    margin-left: auto;
                }
            `,
        },
    },
};

export default xOrderListTableStyle;
